export const detectEmployeeSalaryStructIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /* ----------------------------------
     * DELETE employee salary structure
     * ---------------------------------- */
    const deleteRegex =
        /(delete|remove|erase|drop|get rid of)\s+(the\s+)?(employee salary structure)?\s*(named|called|for)?\s*(.+)?/;

    const deleteMatch = cleaned.match(deleteRegex);

    if (
        deleteMatch &&
        cleaned.includes("employee") &&
        cleaned.includes("salary") &&
        cleaned.includes("structure")
    ) {
        return {
            intent: "delete_employee_salary_structure",
            name: deleteMatch[5]?.trim() || undefined
        };
    }

    /* ----------------------------------
     * CREATE employee salary structure
     * ---------------------------------- */
    const createRegex =
        /(create|add|make|setup|set up|configure|define)\s+(a\s+|new\s+)?(employee salary structure)?\s*(named|called|for)?\s*(.+)?/;

    const createMatch = cleaned.match(createRegex);

    if (
        createMatch &&
        cleaned.includes("employee") &&
        cleaned.includes("salary") &&
        cleaned.includes("structure")
    ) { 
        return {
            intent: "create_employee_salary_structure",
            name: createMatch[5]?.trim() || undefined
        };
    }

    return null;
};
